/**
 * The factor converting a 0–1 ratio to a 0–100 percentage. Exported for the rare caller that
 * needs the factor itself; prefer `getPercentage` so the arithmetic lives in one place.
 */
export const PERCENT_SCALE = 100;

/**
 * Converts a part/whole pair into a 0–100 percentage.
 *
 * Deliberately does not clamp: a `part` larger than `whole` returns more than 100, which callers
 * rely on to detect over-usage (e.g. credits consumed beyond an allocation).
 *
 * `whole` accepts `null`/`undefined` because "no denominator yet" is a real state for allocations
 * and quotas that haven't loaded or aren't set. A missing or zero `whole` returns 0 rather than
 * `Infinity` or `NaN`, so meters render empty instead of breaking.
 *
 * @example
 * getPercentage(25, 200); // 12.5
 * getPercentage(3, 0); // 0
 */
export const getPercentage = (part: number, whole: number | null | undefined): number => {
  if (!whole) {
    return 0;
  }

  return (part / whole) * PERCENT_SCALE;
};
